'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactackleCore = require('reactackle-core');

var _Alert = require('./Alert/Alert');

var _Alert2 = _interopRequireDefault(_Alert);

var _theme = require('./styles/theme');

var _theme2 = _interopRequireDefault(_theme);

var _AlertsWrapperStyled = require('./styles/AlertsWrapperStyled');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _toConsumableArray(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  } else {
    return Array.from(arr);
  }
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

(0, _reactackleCore.registerDefaultComponentTheme)('alertsArea', _theme2.default);
var propTypes = {
  /**
   * Defines timeout for Alert close event
   */
  defaultTimeout: _propTypes2.default.number,

  /**
   * Array of Alerts
   */
  alerts: _propTypes2.default.arrayOf(_propTypes2.default.shape(_extends({}, _Alert2.default.propTypes, {
    content: _propTypes2.default.node
  }))),

  /**
   * Specify function to be called on Close button click
   */
  onClose: _propTypes2.default.func,

  /**
   * Speed of exit animation
   */
  animationDuration: _propTypes2.default.number,

  /**
   * Horizontal position of Alert area relatively ro the window
   */
  positionX: _propTypes2.default.oneOf(['left', 'right']),

  /**
   * Vertical position of Alert area relatively ro the window
   */
  positionY: _propTypes2.default.oneOf(['top', 'bottom'])
};
var defaultProps = {
  defaultTimeout: 3000,
  alerts: [],
  onClose: _reactackleCore.noop,
  animationDuration: 300,
  positionX: 'right',
  positionY: 'bottom'
};

var AlertArea = function (_Component) {
  _inherits(AlertArea, _Component);

  function AlertArea(props) {
    _classCallCheck(this, AlertArea);

    var _this = _possibleConstructorReturn(this, (AlertArea.__proto__ || Object.getPrototypeOf(AlertArea)).call(this, props));

    _this.state = {
      currentAlert: 0,
      queue: [],
      closeAnimation: false
    };
    _this._timeoutId = null;
    _this._handleAlertClose = _this._handleAlertClose.bind(_this);
    _this._closeCurrentAlert = _this._closeCurrentAlert.bind(_this);
    return _this;
  }

  _createClass(AlertArea, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this._setupTimeout();
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var _this2 = this;

      if (nextProps.alerts !== this.props.alerts) {
        this.setState({
          currentAlert: 0,
          queue: [],
          closeAnimation: false
        }, function () {
          _this2._setupTimeout();
        });
      }
    }
  }, {
    key: '_handleAlertClose',
    value: function _handleAlertClose() {
      this.setState({
        closeAnimation: true
      });
      this._timeoutId = setTimeout(this._closeCurrentAlert, this.props.animationDuration);
    }
  }, {
    key: '_closeCurrentAlert',
    value: function _closeCurrentAlert() {
      var _this3 = this;

      var alert = this._getAlert();

      if (alert) {
        this.setState(function (prevState) {
          return {
            currentAlert: prevState.currentAlert + 1,
            closeAnimation: false
          };
        }, function () {
          _this3.props.onClose(alert.id);

          _this3._setupTimeout();
        });
      }
    }
  }, {
    key: '_setupTimeout',
    value: function _setupTimeout() {
      this._timeoutId = null;

      var alert = this._getAlert();

      if (alert) {
        var timeout = alert.timeout === 0 || alert.timeout ? +alert.timeout : this.props.defaultTimeout;

        if (timeout) {
          this._timeoutId = timeout > this.props.animationDuration ? setTimeout(this._handleAlertClose, timeout - this.props.animationDuration) : setTimeout(this._closeCurrentAlert, timeout);
        }
      }
    }
  }, {
    key: '_getAlert',
    value: function _getAlert() {
      var _state = this.state,
          currentAlert = _state.currentAlert,
          queue = _state.queue;
      var queueIndex = currentAlert - this.props.alerts.length;
      if (currentAlert < this.props.alerts.length) return this.props.alerts[currentAlert];else if (queueIndex < queue.length) return queue[queueIndex];
      return null;
    }
  }, {
    key: '_renderCurrentAlert',
    value: function _renderCurrentAlert() {
      var closeAnimation = this.state.closeAnimation;

      var alert = this._getAlert();

      if (alert) {
        return _react2.default.createElement(_Alert2.default, _extends({
          id: alert.id,
          closeAnimation: closeAnimation,
          onClose: this._handleAlertClose
        }, alert), alert.content);
      }

      return null;
    }
  }, {
    key: 'addToQueue',
    value: function addToQueue(alert) {
      var _this4 = this;

      this.setState({
        queue: [].concat(_toConsumableArray(this.state.queue), [alert])
      }, function () {
        if (!_this4._timeoutId) _this4._setupTimeout();
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var currentAlert = this._renderCurrentAlert();

      return _react2.default.createElement(_AlertsWrapperStyled.AlertsWrapperStyled, {
        positionX: this.props.positionX,
        positionY: this.props.positionY
      }, currentAlert);
    }
  }]);

  return AlertArea;
}(_react.Component);

exports.default = AlertArea;
AlertArea.propTypes = propTypes;
AlertArea.defaultProps = defaultProps;
AlertArea.displayName = 'AlertArea';